import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';
import { RemoveLeadingZerosPipe } from '../../../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'app-kn-br-quote-partial-item',
    templateUrl: './kn-br-quote-partial-item.component.html',
    styleUrls: ['./kn-br-quote-partial-item.component.scss'],
    imports: [NgClass, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrQuotePartialItemComponent implements OnInit {
  @Input() orderRefEntries: any;
  @Input() togglePartialOrder: boolean;
  constructor() {}

  ngOnInit() {}
}
